// extracted by mini-css-extract-plugin
export default {"badge":"_3IIT9","small":"nTqn7","buttonSize":"_2_7QG","downloadButton":"_20WId"};